import { datadogRum } from '@datadog/browser-rum';
import { Button, CloseIcon, RetryIcon, Typography } from '@gurupay/gp-ui-library';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router-dom';

export const AppErrorScreen = () => {
	const { t } = useTranslation();

	return (
		<div className="bg-neutral-50 min-h-screen flex flex-col items-center justify-center p-space-24">
			<div className="p-space-4 rounded-full bg-brand-primary-600 text-neutral-white mb-space-8">
				<CloseIcon className="w-space-32 h-space-32" />
			</div>
			<Typography className="mb-space-24 text-center text-neutral-950" level="text">
				{t('errorPage.title')}
			</Typography>
			<Button
				className="flex-row-reverse"
				icon={<RetryIcon className="w-space-24 h-space-24" />}
				onClick={() => window.location.reload()}
				variant="outlined"
			>
				{t('errorPage.tryAgain')}
			</Button>
		</div>
	);
};

export const RouteErrorScreen = () => {
	const error = useRouteError();

	useEffect(() => {
		datadogRum.addError(error, { source: 'custom' });
	}, [error]);

	return <AppErrorScreen />;
};
